<div class="patient">
  <div class="wrapper">
    <app-page-header>
      <div class="l-header-panel">
        <div class="header">
          <nav class="ap-hcrumbs" aria-label="Breadcrumb">
            <a
              class="ap-hcrumbs__link"
              (click)="goDashboard()"
              (keyup.enter)="goDashboard()"
              tabindex="0"
              role="link"
            >
              {{ 'GUI.dashboard.labels.dashboard' | translate }}
            </a>
            <mat-icon class="ap-hcrumbs__sep"
              >{{ dir() === 'rtl' ? 'chevron_left' : 'chevron_right' }}</mat-icon
            >
            <span class="ap-hcrumbs__current"
              >{{ 'GUI.dashboard.labels.payments to artisan sonics' | translate }}</span
            >
          </nav>
        </div>
      </div>
    </app-page-header>

    <main class="l-deashboard">
      <section class="ap" [attr.dir]="dir()">
        <!-- ======= Title Bar (Start) ======= -->
        <header class="ap-head">
          <div class="ap-head__left">
            <div class="ap-greeting">{{ greeting() }}</div>
            <div class="ap-title">
              {{ userName }} <span>{{ userNameLast }}</span>
              @if (isAdmin) {
              <span class="ap-admin-badge"
                >{{ 'GUI.dashboard.labels.chips.admin' | translate }}</span
              >
              }
            </div>
            <div class="ap-subtitle">
              {{ today() }} · {{ 'GUI.dashboard.labels.payments at a glance' | translate }}
            </div>
          </div>
        </header>
        <!-- ======= Title Bar (End) ======= -->

        <!-- ======= Summary (Start) ======= -->
        <div class="ap-summary">
          @if (loading()) { @for (_ of [1,2,3]; track $index) {
          <div class="ap-kpi">
            <div class="skel" style="width: 70px; height: 14px; margin-bottom: 8px"></div>
            <div class="skel" style="width: 90px; height: 24px"></div>
          </div>
          } } @else {
          <div class="ap-kpi">
            <div class="ap-kpi__label">
              {{ 'GUI.dashboard.labels.chips.this month' | translate }}
            </div>
            <div class="ap-kpi__val ap-kpi__val--teal">{{ money(summary().thisMonth) }}</div>
          </div>
          <div class="ap-kpi">
            <div class="ap-kpi__label">{{ 'GUI.dashboard.labels.documents' | translate }}</div>
            <div class="ap-kpi__val">{{ summary().count }}</div>
          </div>
          <div class="ap-kpi">
            <div class="ap-kpi__label">{{ 'GUI.dashboard.labels.last payment' | translate }}</div>
            <div class="ap-kpi__val" [class.ap-kpi__val--sm]="!summary().lastLabel">
              {{ summary().lastLabel || ('GUI.dashboard.labels.no data available' | translate) }}
            </div>
          </div>
          }
        </div>
        <!-- ======= Summary (End) ======= -->

        <!-- ======= Payments Card (Start) ======= -->
        <div class="ap-card">
          <div class="ap-toolbar">
            <div class="ap-search">
              <mat-icon>search</mat-icon>
              <input
                #searchInput
                type="text"
                [value]="search()"
                (input)="search.set(searchInput.value)"
                [placeholder]="'GUI.dashboard.labels.search payments' | translate"
              />
            </div>
            <select #yearSelect class="ap-select" (change)="yearFilter.set(yearSelect.value)">
              <option value="">{{ 'GUI.dashboard.labels.all years' | translate }}</option>
              @for (y of years(); track y) {
              <option [value]="y" [selected]="yearFilter() === y">{{ y }}</option>
              }
            </select>
            <select #typeSelect class="ap-select" (change)="typeFilter.set(typeSelect.value)">
              <option value="">{{ 'GUI.dashboard.labels.all types' | translate }}</option>
              @for (t of types(); track t) {
              <option [value]="t" [selected]="typeFilter() === t">{{ t }}</option>
              }
            </select>
          </div>

          <div class="ap-list">
            @if (loading()) { @for (_ of [1,2,3,4,5]; track $index) {
            <div class="ap-row ap-row--skel">
              <div class="ap-row__main">
                <span class="skel" style="width: 42%; height: 15px"></span>
                <span class="skel" style="width: 62%; height: 12px; margin-top: 8px"></span>
              </div>
              <span class="skel" style="width: 64px; height: 15px"></span>
              <span class="skel" style="width: 56px; height: 22px; border-radius: 20px"></span>
              <span class="skel" style="width: 30px; height: 30px"></span>
              <span class="skel" style="width: 30px; height: 30px"></span>
            </div>
            } } @else { @for (p of filtered(); track p.id ?? p.documentNumber ?? $index) {
            <div class="ap-row">
              <div class="ap-row__main">
                <div class="ap-row__name">
                  {{ p.name || ('GUI.dashboard.labels.payment' | translate) }}
                </div>
                <div class="ap-row__meta">
                  @if (p.documentNumber) { #{{ p.documentNumber }} } @if (p.dateLabel) {
                  <span class="ap-row__date">{{ p.dateLabel }}</span> }
                </div>
              </div>
              <div class="ap-row__amount" [class.ap-row__amount--credit]="p.credit">
                {{ money(p.signed) }}
              </div>
              <span class="ap-row__status" [class.ap-row__status--credit]="p.credit">
                {{ (p.credit ? 'GUI.dashboard.labels.credit' : 'GUI.dashboard.labels.paid') |
                translate }}
              </span>
              <div class="ap-row__actions">
                <button
                  type="button"
                  class="ap-icon-btn"
                  (click)="openPreview(p)"
                  [attr.aria-label]="'GUI.dashboard.labels.preview' | translate"
                  [disabled]="!p.id"
                >
                  <mat-icon>visibility</mat-icon>
                </button>
                <a
                  class="ap-icon-btn"
                  [href]="downloadHref(p)"
                  [attr.aria-label]="'GUI.dashboard.buttons.download' | translate"
                >
                  <mat-icon>download</mat-icon>
                </a>
              </div>
            </div>
            } @empty {
            <div class="ap-empty">
              {{ 'GUI.dashboard.labels.No payment records found' | translate }}
            </div>
            } }
          </div>
        </div>
        <!-- ======= Payments Card (End) ======= -->
      </section>
    </main>
    <app-bottombar></app-bottombar>
  </div>
</div>

<app-embed-modal
  [url]="modalUrl()"
  [title]="'GUI.dashboard.labels.payments to artisan sonics' | translate"
  (closed)="closeModal()"
></app-embed-modal>
